import styled, { css } from 'styled-components'
import { ReadMore } from '@velasca/ui/read-more'

export const MoreDetailsWrapper = styled.div`
  width: 100%;

  background-color: ${({ theme }) => theme.colors.boxBackground};
  padding: 3rem 2rem 1rem 2rem;
`

export const ContainerWrap = styled.div<{ noLastBorder: boolean }>`
  width: 100%;
  display: block;
  padding: 2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  :last-child {
    ${({ noLastBorder }) =>
      noLastBorder &&
      css`
        border-bottom: none;
      `};
    @media screen and (min-width: 768px) {
      border-bottom: none;
    }
  }
  ::first-letter {
    text-transform: uppercase;
  }
`

export const Column = styled.div`
  display: inline-block;
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 50%;
    padding-right: 4rem;

    :last-child {
      padding-right: 0;
    }
  }
`

export const ColumnsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const StyledReadMore = styled(ReadMore)`
  margin-top: 1rem;
  justify-content: flex-start;
`
